import React from 'react';
import { FadeIn } from './FadeIn';
import { AlertCircle, CheckCircle, Activity, Info, ShieldCheck, MessageSquare, CalendarClock } from 'lucide-react';
export const ReportPreview = () => {
  const outcomes = [{
    icon: <ShieldCheck size={22} className="text-sage" data-id="element-261" />,
    title: 'Принять решение спокойно',
    desc: 'Без давления и в своём темпе. У вас на руках две независимые оценки, а не одно мнение, услышанное в спешке между приёмами.'
  }, {
    icon: <MessageSquare size={22} className="text-sage" data-id="element-262" />,
    title: 'Прийти к своему врачу подготовленным',
    desc: 'С готовым списком конкретных вопросов и аргументов. Разговор будет содержательным, а не «доктор, вы лучше знаете».'
  }, {
    icon: <CalendarClock size={22} className="text-sage" data-id="element-263" />,
    title: 'Понять план на 3–6 месяцев',
    desc: 'Что делать сейчас, какие симптомы отслеживать, и в какой момент важно снова обратиться к врачу.'
  }];
  return <section className="py-24 bg-beigeLight overflow-hidden" data-id="element-264">
      <div className="max-w-6xl mx-auto px-6" data-id="element-265">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-266">
          <div data-id="element-267">
            <FadeIn data-id="element-268">
              <h2 className="font-serif text-3xl md:text-4xl text-navy mb-6" data-id="element-269">
                Что вы получите в отчёте
              </h2>
              <p className="text-lg text-navyLight mb-8 leading-relaxed" data-id="element-270">
                Структурированный PDF на 8–12 страниц. Сначала — короткое резюме
                на понятном языке. Дальше — детальный разбор каждого вопроса с
                обоснованием от двух экспертов.
              </p>

              <ul className="space-y-6" data-id="element-271">
                {['Насколько обоснована рекомендация к операции по представленным данным', 'Какие альтернативы существуют согласно клиническим протоколам', 'Оценка срочности — есть ли признаки, требующие быстрых действий', 'Красные флаги — симптомы, при которых важно обратиться к врачу немедленно', 'Список вопросов, которые стоит задать вашему лечащему врачу'].map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-272">
                    <div className="w-6 h-6 rounded-full bg-sage/20 flex items-center justify-center shrink-0 mt-0.5" data-id="element-273">
                      <CheckCircle size={14} className="text-sage" data-id="element-274" />
                    </div>
                    <span className="text-lg text-navy" data-id="element-275">{item}</span>
                  </li>)}
              </ul>
            </FadeIn>
          </div>

          <FadeIn delay={0.2} direction="left" data-id="element-276">
            <div className="bg-white rounded-2xl shadow-xl p-8 border border-beige relative transform rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-277">
              <div className="absolute top-0 left-0 w-full h-2 bg-sage rounded-t-2xl" data-id="element-278" />

              <div className="border-b border-beige pb-6 mb-6" data-id="element-279">
                <div className="text-sm text-navyLight uppercase tracking-wider font-medium mb-2" data-id="element-280">
                  Экспертное заключение
                </div>
                <h3 className="font-serif text-2xl text-navy" data-id="element-281">
                  Пациент: Анонимно, 45 лет
                </h3>
              </div>

              <div className="space-y-6" data-id="element-282">
                <div data-id="element-283">
                  <div className="flex items-center gap-2 mb-3" data-id="element-284">
                    <Activity size={18} className="text-navyLight" data-id="element-285" />
                    <h4 className="font-medium text-navy" data-id="element-286">
                      Обоснованность рекомендации
                    </h4>
                  </div>
                  <div className="bg-sageLight text-sageDark px-4 py-3 rounded-lg inline-flex items-center gap-2 font-medium text-sm" data-id="element-287">
                    <CheckCircle size={16} data-id="element-288" />
                    По представленным данным — признаков, требующих неотложного
                    вмешательства, не выявлено
                  </div>
                </div>

                <div data-id="element-289">
                  <div className="flex items-center gap-2 mb-3" data-id="element-290">
                    <Info size={18} className="text-navyLight" data-id="element-291" />
                    <h4 className="font-medium text-navy" data-id="element-292">
                      Альтернативы по протоколам
                    </h4>
                  </div>
                  <p className="text-navyLight bg-offwhite p-4 rounded-lg text-sm leading-relaxed" data-id="element-293">
                    В клинических рекомендациях для подобных случаев
                    рассматриваются: курс НПВС (7–10 дней), специализированная
                    ЛФК под контролем реабилитолога, селективная блокада при
                    сохранении болевого синдрома.
                  </p>
                </div>

                <div data-id="element-294">
                  <div className="flex items-center gap-2 mb-3" data-id="element-295">
                    <AlertCircle size={18} className="text-navyLight" data-id="element-296" />
                    <h4 className="font-medium text-navy" data-id="element-297">
                      Красные флаги (когда обратиться к врачу немедленно)
                    </h4>
                  </div>
                  <div className="border-l-2 border-red-400 pl-4 py-1" data-id="element-298">
                    <p className="text-sm text-navyLight" data-id="element-299">
                      Онемение в области промежности, нарушение функции тазовых
                      органов, резкая слабость в стопе.
                    </p>
                  </div>
                </div>

                <div className="text-xs text-navyLight/60 italic pt-2 border-t border-beige/60" data-id="element-300">
                  Окончательное решение о тактике лечения принимаете вы вместе с
                  вашим лечащим врачом.
                </div>
              </div>

              <div className="absolute bottom-8 right-8 opacity-10 pointer-events-none" data-id="element-301">
                <div className="w-24 h-24 rounded-full border-4 border-navy flex items-center justify-center transform -rotate-12" data-id="element-302">
                  <span className="font-serif font-bold text-navy text-lg text-center leading-tight" data-id="element-303">
                    INDEPENDENT
                    <br data-id="element-304" />
                    REVIEW
                  </span>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} data-id="element-305">
          <div className="mt-24 pt-16 border-t border-beige" data-id="element-306">
            <h3 className="font-serif text-2xl md:text-3xl text-navy text-center mb-4" data-id="element-307">
              Что вы сможете сделать с этим отчётом
            </h3>
            <p className="text-center text-navyLight mb-12 max-w-2xl mx-auto" data-id="element-308">
              Это не просто документ «для архива». Это инструмент, с которым вы
              возвращаетесь в диалог с врачами на равных.
            </p>

            <div className="grid md:grid-cols-3 gap-6" data-id="element-309">
              {outcomes.map((item, idx) => <FadeIn key={idx} delay={0.1 * idx} data-id="element-310">
                  <div className="bg-white p-8 rounded-2xl h-full border border-beige/50" data-id="element-311">
                    <div className="w-12 h-12 rounded-full bg-sageLight flex items-center justify-center mb-5" data-id="element-312">
                      {item.icon}
                    </div>
                    <h4 className="font-medium text-navy text-lg mb-3" data-id="element-313">
                      {item.title}
                    </h4>
                    <p className="text-navyLight text-sm leading-relaxed" data-id="element-314">
                      {item.desc}
                    </p>
                  </div>
                </FadeIn>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};